import {useQuery} from '@tanstack/react-query'
import {AxiosError, AxiosInstance} from 'axios'

const DepartmentUpmIdQueryKey = 'upm-department-id-by-pxtrendtag-suggestion'

type DepartmentUpmIdByPxTrendTagSuggestionArgs = {
  plantId: string
  pxTrendTag: string
  axiosInstance: AxiosInstance
}

export const getQueryKeyDepartmentUpmIdByPxTrendTagSuggestion = (
  plantId: string,
  pxTrendTag: string
) => [`${DepartmentUpmIdQueryKey}-${plantId}-${pxTrendTag}`]

export const fetchDepartmentUpmIdByPxTrendTagSuggestion = async ({
  plantId,
  pxTrendTag,
  axiosInstance
}: DepartmentUpmIdByPxTrendTagSuggestionArgs): Promise<string> => {
  const response = await axiosInstance.get<string>(
    `/shifthandover/${plantId}/upm-department-id-by-pxtrendtag-suggestion/${pxTrendTag}`
  )

  return response.data
}

export const useStoppedMainEquipmentByPxTrendTagSuggestion = (
  {plantId, pxTrendTag, axiosInstance}: DepartmentUpmIdByPxTrendTagSuggestionArgs,
  {enabled}: {enabled: boolean}
) => {
  return useQuery<string, AxiosError>({
    queryKey: getQueryKeyDepartmentUpmIdByPxTrendTagSuggestion(plantId, pxTrendTag),
    queryFn: async () =>
      fetchDepartmentUpmIdByPxTrendTagSuggestion({plantId, pxTrendTag, axiosInstance}),
    enabled
  })
}
